export const SocialMediaLinks = {
  LINK_DIN: "https://www.linkedin.com/company/fiva-e-s/",
  YOU_TUBE: "https://www.youtube.com/channel/UCruDEBFItmXrN14XxbVOdOQ",
  TWITTER: "https://twitter.com/FivaEnergy",
  INSTAGRAM: "https://www.instagram.com/fiva.es/",
  FACEBOOK: "https://www.facebook.com/profile.php?id=61550677975264",
}
